<h2 mat-dialog-title>Anwendung {{ anwendung?.anwendung }} für {{ material.bezeichnung }}</h2>
<mat-dialog-content>
    <mat-form-field *ngIf="!anwendung" style="width: 100%" [attr.data-cy]="'aaaadaad_mat-form-field_1_8_'">
        <mat-label [attr.data-cy]="'aaaadaad_mat-label_1_9_'">Anwendung</mat-label>
        <input
            type="text"
            matInput
            placeholder="Anwendung"
            [formControl]="anwendungCtrl"
            [attr.data-cy]="'aaaadaad_input_1_1_'"
        />
    </mat-form-field>
    <mat-form-field style="margin-right: 12px" [attr.data-cy]="'aaaadaad_mat-form-field_2_8_'">
        <mat-label [attr.data-cy]="'aaaadaad_mat-label_2_9_'">QS Schl&uuml;ssel</mat-label>
        <input type="number" matInput [formControl]="qsKeyCtrl" [attr.data-cy]="'aaaadaad_input_2_1_'" />
    </mat-form-field>
    <mat-form-field style="margin-right: 12px" [attr.data-cy]="'aaaadaad_mat-form-field_3_8_'">
        <mat-label [attr.data-cy]="'aaaadaad_mat-label_3_9_'">HIT Schl&uuml;ssel</mat-label>
        <input type="number" matInput [formControl]="hitKeyCtrl" [attr.data-cy]="'aaaadaad_input_3_1_'" />
    </mat-form-field>
    <!-- <mat-form-field style="width: 100%;" [attr.data-cy]="'aaaadaad_mat-form-field_4_8_'">
    <mat-label [attr.data-cy]="'aaaadaad_mat-label_4_9_'">Tierart</mat-label>
    <mat-select [formControl]="tierartCtrl" [compareWith]="tierartComparator" multiple [attr.data-cy]="'aaaadaad_mat-select_1_6_'">
      <mat-option *ngFor="let t of tierarten" [value]="t" [attr.data-cy]="'aaaadaad_mat-option_1_7_'">{{t.tierart}}</mat-option>
    </mat-select>
  </mat-form-field> -->
    <table style="width: 100%" class="phito-table">
        <thead>
            <tr>
                <th></th>
                <th></th>
                <th>Tierart</th>
                <th>Wartezeit Fleisch</th>
                <th>Wartezeit Milch</th>
                <th>Wartezeit Eier</th>
                <th>Kommentar</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let t of anwendungTierarten; let i = index">
                <td></td>
                <td>
                    <mat-checkbox
                        [attr.data-cy]="'aaaadaad_mat-checkbox_1_3_' + i"
                        [(ngModel)]="selectedTierarten[+t.tierart_id]"
                    >
                    </mat-checkbox>
                </td>
                <td [attr.data-cy]="'aaaadaad_td_4_1_' + i">{{ t.tierart }}</td>
                <td
                    ><input
                        matInput
                        type="number"
                        style="border: 1px solid lightgray; border-radius: 5px; padding: 3px; width: 50px"
                        [(ngModel)]="t.wartezeit_fleisch"
                        [attr.data-cy]="'aaaadaad_input_4_1_' + i"
                /></td>
                <td
                    ><input
                        matInput
                        type="number"
                        style="border: 1px solid lightgray; border-radius: 5px; padding: 3px; width: 50px"
                        [(ngModel)]="t.wartezeit_milch"
                        [attr.data-cy]="'aaaadaad_input_5_1_' + i"
                /></td>
                <td
                    ><input
                        matInput
                        type="number"
                        style="border: 1px solid lightgray; border-radius: 5px; padding: 3px; width: 50px"
                        [(ngModel)]="t.wartezeit_eier"
                        [attr.data-cy]="'aaaadaad_input_6_1_' + i"
                /></td>
                <td
                    ><input
                        matInput
                        type="text"
                        style="border: 1px solid lightgray; border-radius: 5px; padding: 3px; width: 150px"
                        [(ngModel)]="t.kommentar"
                        [attr.data-cy]="'aaaadaad_input_7_1_' + i"
                /></td>
            </tr>
        </tbody>
    </table>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()" [attr.data-cy]="'aaaadaad_button_1_0_'">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="save()" [attr.data-cy]="'aaaadaad_button_2_0_'"
        >Speichern</button
    >
</mat-dialog-actions>
